import { EnumName } from "../../utils/enums";
import { OptionsListFilter, OptionsListFilterProps } from "./OptionsListFilter";

export const ContainerTypesFilter: React.FC<OptionsListFilterProps> = (props) => {
  return <OptionsListFilter enumName={EnumName.ContainerTypes} {...props} />;
};
